<template>
  <div class="client feedback toolbar">
    <div :class="{ 'show-on-hover': onHover }">
      <v-toolbar :flat="onHover" dense :color="color">
        <v-toolbar-items>
          <v-btn
            dark
            depressed
            class="red darken-3 reject"
            @click.stop="thumbsDown = true"
          >
            <v-icon>mdi-thumb-down</v-icon>
          </v-btn>
        </v-toolbar-items>

        <v-spacer />

        <v-toolbar-items>
          <v-btn
            dark
            depressed
            class="green darken-3 approve"
            @click.stop="thumbsUp = true"
          >
            <v-icon>mdi-thumb-up</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </div>

    <!-- Positive Response -->
    <v-dialog v-model="thumbsUp" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">
          <v-avatar size="40">
            <img
              v-if="profile && profile.avatar"
              :src="profile.avatar"
              v-img-orientation-changer
            />
            <img v-else src="/img/missing/avatars/original.png" />
          </v-avatar>
          <span class="px-3">{{ profile.fullName }}</span>
        </v-card-title>
        <div class="text-xs-center pa-1">
          <v-avatar size="140" :color="themes.client.light.success">
            <v-icon size="100" dark>mdi-thumb-up</v-icon>
          </v-avatar>
        </div>
        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-text-field
              label="Optional Comment"
              v-model="response"
              :color="themes.client.light.input"
            />

            <div class="text-xs-right">
              <v-btn
                flat
                :color="themes.client.light.muted"
                @click.stop="thumbsUp = false"
              >
                Cancel
              </v-btn>
              <v-btn
                type="submit"
                :color="themes.client.light.primaryActionButton"
                >Confirm</v-btn
              >
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Negative Response -->
    <v-dialog v-model="thumbsDown" max-width="400">
      <v-card>
        <v-card-title class="title">
          <v-avatar size="40">
            <img
              v-if="profile && profile.avatar"
              :src="profile.avatar"
              v-img-orientation-changer
            />
            <img v-else src="/img/missing/avatars/original.png" />
          </v-avatar>
          <span class="px-3">{{ profile.fullName }}</span>
        </v-card-title>
        <div class="text-xs-center pa-1">
          <v-avatar size="140" :color="themes.client.light.error">
            <v-icon size="100" dark>mdi-thumb-down</v-icon>
          </v-avatar>
        </div>
        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-text-field
              label="Optional Comment"
              v-model="response"
              :color="themes.client.light.input"
            />

            <div class="text-xs-right">
              <v-btn
                flat
                :color="themes.client.light.muted"
                @click.stop="thumbsDown = false"
              >
                Cancel
              </v-btn>
              <v-btn
                type="submit"
                :color="themes.client.light.primaryActionButton"
                >Confirm</v-btn
              >
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    feedbackRequest: { type: Object, required: true },
    onHover: { type: Boolean, default: () => false },
    color: { type: String, default: () => "white" }
  },

  data() {
    return {
      thumbsDown: false,
      thumbsUp: false,
      response: ""
    };
  },

  computed: {
    profile() {
      return this.feedbackRequest.opportunityApplication.profile;
    },

    isPositive() {
      return this.thumbsUp && !this.thumbsDown;
    }
  },

  methods: {
    submit() {
      if (this.thumbsUp || this.thumbsDown) {
        this.$store
          .dispatch("client/feedbackRequests/update", {
            ...this.feedbackRequest,
            isPositive: this.isPositive,
            response: this.response
          })
          .then(
            () => {
              this.resetData();
              this.$emit("done");
              this.$store.dispatch("snackbarSuccess", "Thank you");
            },
            () => this.$store.dispatch("snackbarError", "Failed to Save")
          );
      }
    },

    resetData() {
      this.thumbsDown = false;
      this.thumbsUp = false;
      this.response = "";
    }
  }
};
</script>

<style lang="scss">
.client.feedback.toolbar {
  width: 100%;

  &:hover div.show-on-hover {
    opacity: 1;
  }

  div.show-on-hover {
    position: absolute;
    width: 100%;
    opacity: 0;
  }

  nav div.v-toolbar__content {
    padding: 0;
    margin-top: -48px;
  }
  .approve {
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .reject {
    border-top-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
